// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__19XNT","info":"UpdateTermsInfo_info__EeOtx"};